(function() {
  'use strict';

  const ARROW_SVG = '<svg class="btn__arrow" width="16" height="12" viewBox="0 0 16 12" fill="none" aria-hidden="true"><path d="M10 11L15 6M15 6L10 1M15 6L1 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /**
   * Détecte la variante à appliquer au bouton
   * @returns {'orange'|'primary'|'white'|null} null = pas d'animation
   */
  function detectVariant(btn) {
    // 0. Exclusions : boutons spécifiques qu'on ne touche pas (ni curves
    //    SVG, ni flèche, ni iris-reveal). Le bouton checkout est un
    //    .button.button--primary mais doit rester sobre (panier final).
    if (btn.classList.contains('checkout-button')) {
      return null;
    }

    // 1. Add to cart → orange (priorité max)
    if (btn.classList.contains('product-form__add-button')) {
      return 'orange';
    }

    // 2. Secondary (charte AlloPunaise : --color-cta-secondary = orange) →
    //    même look animé que l'add-to-cart. Utilisé p.ex. par le bouton
    //    "Envoyer" du formulaire "Poser une question" article.
    if (btn.classList.contains('button--secondary')) {
      return 'orange';
    }

    // 3. Primary → bleu OU blanc selon la couleur de fond
    if (btn.classList.contains('button--primary')) {
      // On détecte la couleur de fond effective du bouton
      const bg = getComputedStyle(btn).backgroundColor;
      if (isWhiteish(bg)) return 'white';
      return 'primary';
    }

    // 4. CTA banner legacy markup (div.cd-btn--primary tapé en HTML brut
    //    dans le rich-text des articles) → même look que primary
    if (btn.classList.contains('cd-btn--primary')) {
      return 'primary';
    }

    // 5. Autres boutons → on ne touche pas
    return null;
  }

  /**
   * Teste si une couleur CSS (rgb/rgba) est "blanche ou très claire"
   */
  function isWhiteish(color) {
    const m = color.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if (!m) return false;
    const [r, g, b] = [parseInt(m[1]), parseInt(m[2]), parseInt(m[3])];
    // Luminance perçue > 240 → on considère blanc
    return r > 240 && g > 240 && b > 240;
  }

 function buildCurvesSVG(strokeColor) {
  return '<span class="btn__curves" aria-hidden="true">' +
    // SVG gauche — 162×56 natif, ancré à gauche
    '<svg class="btn__curve-svg btn__curve-svg--left" width="162" height="56" viewBox="0 0 162 56" xmlns="http://www.w3.org/2000/svg">' +
      '<path class="btn__curve-left" d="M-35.3982 51.6392L-13.5138 38.9011C-5.05379 33.9771 -5.09904 21.7419 -13.5945 16.8835L-35.57 4.30201" stroke="' + strokeColor + '" stroke-width="10.9122" fill="none"/>' +
    '</svg>' +
    // SVG droit — 162×56 natif, ancré à droite
    '<svg class="btn__curve-svg btn__curve-svg--right" width="162" height="56" viewBox="0 0 162 56" xmlns="http://www.w3.org/2000/svg">' +
      '<path class="btn__curve-right" d="M198.846 4.36414L176.962 17.1022C168.502 22.0262 168.547 34.2614 177.042 39.1198L199.018 51.7013" stroke="' + strokeColor + '" stroke-width="10.9122" fill="none"/>' +
    '</svg>' +
  '</span>';
}

  function enhanceButton(btn) {
    if (btn.dataset.animated === 'true') return;

    const variant = detectVariant(btn);
    if (!variant) return;

    // Couleur des courbes selon la variante
    const curveColor = (variant === 'primary') ? '#0018AD' : '#448FF8';

    // On préserve le contenu original (label, icônes custom, etc.)
    const originalHTML = btn.innerHTML;

    // Marquage + variante + nouveau DOM
    btn.dataset.animated = 'true';
    btn.dataset.variant = variant;
    btn.classList.add('is-animated', 'is-variant-' + variant);

    // Les règles d'animation sont scopées à `.button.is-animated`. Si on traite
    // un élément qui n'a pas la classe .button (ex : div.cd-btn--primary dans
    // le rich-text des articles), on l'ajoute pour activer le même CSS.
    if (!btn.classList.contains('button')) btn.classList.add('button');

    btn.innerHTML =
      buildCurvesSVG(curveColor) +
      '<span class="btn__circle btn__circle--mid" aria-hidden="true"></span>' +
      '<span class="btn__circle btn__circle--end" aria-hidden="true"></span>' +
      '<span class="btn__content"><span class="btn__label">' + originalHTML + '</span>' + ARROW_SVG + '</span>';
  }

  function enhanceAll(root) {
    root = root || document;
    const selector = '.product-form__add-button.button, .button.button--primary, .button.button--secondary, .cta-banner .cd-btn--primary';
    root.querySelectorAll(selector).forEach(enhanceButton);
  }

  // Run initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { enhanceAll(); });
  } else {
    enhanceAll();
  }

  // Observer pour les boutons rechargés (AJAX panier, sliders, variantes, etc.)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.matches) {
          if (node.matches('.product-form__add-button.button, .button.button--primary, .button.button--secondary, .cta-banner .cd-btn--primary')) {
            enhanceButton(node);
          }
          if (node.querySelectorAll) enhanceAll(node);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();